export default __webpack_public_path__ + "locales/tr/SocialAuthWelcomeDialog.json?hash=2ad67898ec2ab2ac23e470ed4b5f29ad";